import React from 'react';
import { cn } from '../../utils/cn';
import type { TextProps } from '../../types/components';

const textSizes = {
  xs: 'text-xs',
  sm: 'text-sm',
  base: 'text-base',
  lg: 'text-lg',
  xl: 'text-xl',
};

const textWeights = {
  light: 'font-light',
  normal: 'font-normal',
  medium: 'font-medium',
  semibold: 'font-semibold',
  bold: 'font-bold',
};

const textAligns = {
  left: 'text-left',
  center: 'text-center',
  right: 'text-right',
  justify: 'text-justify',
};

export const Text = React.forwardRef<HTMLParagraphElement, TextProps>(
  (
    {
      size = 'base',
      weight = 'normal',
      color,
      align = 'left',
      truncate = false,
      italic = false,
      underline = false,
      strikethrough = false,
      children,
      className,
      testId,
      ...props
    },
    ref
  ) => {
    const baseClasses = [
      'font-sans',
      'leading-normal',
    ];

    const sizeClass = textSizes[size] || textSizes.base;
    const weightClass = textWeights[weight] || textWeights.normal;
    const alignClass = textAligns[align] || textAligns.left;

    const classes = cn(
      baseClasses,
      sizeClass,
      weightClass,
      alignClass,
      {
        'truncate': truncate,
        'italic': italic,
        'underline': underline,
        'line-through': strikethrough,
        'text-gray-700': !color,
      },
      className
    );

    const style = color ? { color } : undefined;

    return (
      <p
        ref={ref}
        className={classes}
        style={style}
        data-testid={testId}
        {...props}
      >
        {children}
      </p>
    );
  }
);

Text.displayName = 'Text';